<template>
  <div class="choose-room setMobileHeroNavigation">
    <template v-for="(room) in rooms">
      <template v-if="room.index === roomSelected.index">
        <img v-for="(asset, assetIndex) in room.assets" :key="assetIndex"  :class="asset.class" :style="asset.style" :src="asset.component"  />
      </template>
    </template>

    <div :class="roomSelected.index === 4 ? 'menu-choose-room menu-light' : 'menu-choose-room'">
      <h1 :class="roomSelected.index === 6 ? 'font-light' : ''">Onde sua TV vai ficar?</h1>
      <div class="select-room-pc">
        <button 
          v-for="(room, index) in rooms" 
          :key="index" 
          :class="roomSelected.index === 4 || roomSelected.index === 6 ? 
            (room.index === roomSelected.index ? 'button quaternary selectedLight' : 'button quaternary') : 
            (room.index === roomSelected.index ? 'button tertiary selected' : 'button tertiary')"
          :id="room.analytics"
          v-on:click="selectRoom(room)"
        >
          {{room.name}}
        </button>
      </div>
      <div class="custom-select" @blur="open = false">
        <div class="selected" :class="{ open: open, 'font-light': roomSelected.index === 6 }" @click="open = !open">
          {{ roomSelected.name }}
          <div class="custom-select-btn">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L7 7L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="items" :class="{ selectHide: !open }">
          <div
            v-for="(room, i) of rooms"
            :key="i"
            @click="selectRoom(room)"
            :id="room.analytics"
          >
            {{ room.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rooms from '../../constants/rooms';
import ArrowDownIcon from '../../assets/arrow-down.svg'

export default {
  name: "ChooseYourRoom",
  components: {},
  props: [
    "sendAnalytics", 
    "roomSelected",
  ],
  data() {
    return { 
      rooms,
      open: false,
      tabIndex: 0,
      ArrowDownIcon
    }
  },
  computed: {},
  mounted() {},
  methods: {
    selectRoom(room){
    
      this.$emit('clickedTvRoom', room);
      this.open = false;
      this.selected = room;
    }
  },
};
</script>

<style lang="scss">
@import "../../sass/main.scss";

@media (max-width: $bp-mobile) {
  @import '../../sass/media-query/mobile-assets-choose-your-room.scss';
}

.choose-room{
  display: flex;
  justify-content: center;
  align-items: flex-start;

  position: relative;

  max-height: 730px;

  overflow: hidden;

  .background-choose-your-room{
    width: 100%;
    height: 730px;
  }

  .tv-choose-your-room{
    top: calc(48% - 179.5px);
    padding-right: 40px;
    z-index: 1;
  }

  .absolute-choose-your-room{
    position: absolute;
  }

  .transform-choose-your-room{
    transform: translateX(-50%);
  }

  .menu-choose-room{
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: column;

    position: absolute;
    top: 15px;

    h1{
      font-family: $font-family-title;
      font-size: 2.5rem;
      line-height: normal;
      z-index: 1;
    }

    .select-room-pc{
      display: flex;
      padding-top: 1.2rem;

      gap: 0.5rem;

      .selected{
        background-color: $color-dark-default;
        color: $color-light-default;
      }

      .selectedLight{
        background-color: $color-dark-default;
        border-color: $color-dark-default;
      }

      button {
        text-shadow: .7px .7px .7px rgba(0,0,0,0.3);
        backdrop-filter: blur(10px);
      }
    }

    .custom-select{
      display: none;
    }
    .custom-select-btn{
      width: 60px;
      height: 38px;
      background: #6E6A69;
      border-radius: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // .custom-select-btn svg{
      
    // }

  }

  .menu-light{
    color: $color-light-default;
  }

  .font-light {
    @media (max-width: $bp-mobile) {
      color: $color-light-default;
      text-shadow: none;
    }
  }

  @media (max-width: 890px) {
    .largeAssets {
      width: 100%;
    }
    .extraLargeAssets{
      width: 67.5%;
      padding-left: 5%;
    }
  }
}

@media (max-width: $bp-mobile) {
  .menu-light {
    h1 {
      color: $color-dark-default;
      margin: 0 $margin-side-title-mobile;
      font-size: 2rem;
      line-height: 2.3rem;
    }
  }
  .choose-room{
    max-height: 530px;

      .background-choose-your-room {
        height: 530px;
      }

      .tv-choose-your-room{
        width: 60%;
      }

      .menu-choose-room{
        width: 100%;
        padding-top: 5rem;
        z-index: 999;

        .select-room-pc{
          display: none;
        }

        .custom-select {
          display: block;
          position: relative;

          width: 80%;

          line-height: 87px;

          padding-top: 1rem;

          .selected {
            -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-family: "SamsungOneBold";
            font-size: 1rem;
            background-color: #fff;
            color: #000;
            border-radius: 10rem;
            border: 1px solid transparent;
            cursor: pointer;
            height: 46px;
            padding: 0px 4px 0 33px;
            margin-top:1rem;
            position: relative;
            z-index: 3;
            // &.font-light {
            //   color: white;
            // }
            .open {
              border: 1px solid #ad8225;
              border-radius: 6px 6px 0px 0px;
            }
            svg{
              width: 14px;
              height: 14px;
              transform: rotate(180deg);
           
            }
           
          
          }
          .selected.open{
              svg{
                transform: rotate(0deg);
              }
            }
          .items {
            position: absolute;          
            left:0;
            top:55px;
            z-index: 2;
            max-height: 220px;
            overflow-y: scroll;
            background: #F0F0F0;
            border: 2px solid #FFFFFF;
            border-radius: 0px 0px 16px 16px;
            width: 100%;
            padding: 20px 33px 0;
            div {
              font-family: $font-family-default-bold;
              font-size: 1rem;
              color: $color-dark-default;
              cursor: pointer;
              user-select: none;
              border-bottom: solid 1px #fff;
              height: 51px;
              display: flex;
              align-items: center;
            }
            div:last-child{
              border: none;
            }
          }

          .selectHide {
            display: none;
          }
        }
      }

    @media (min-width: 620px) {
      .plant-livingroom, .luminaire, .bookcase-livingroom{
        bottom: 0!important;
      }
    }

    @media (max-width: 630px) {
      .tv-bedroom{
        padding-top: 10%!important;
      }

      .tv-kitchen{
        padding-top: 10%;
      }

      .tv-outside{
        padding-top: 10%;
      }

      .tv-office{
        padding-top: 10%;
      }
    }

    @media (max-width: 572px) {
      .tv-living-room{
        width: 60%;
        top: 42%!important;
      }

      .tv-bedroom{
        width: 60%!important;
        top: 22%!important;
        left: 26%!important;
      }      
      
      .tv-kitchen{
        padding-top: 20%;
      }

      .tv-room{
        padding-top: 13%!important;
      }

      .tv-outside{
        padding-top: 20%!important;
      }

      .menu-choose-room{
        h1{
          font-size: 1.5rem;
          line-height: 2rem;
        }

        .custom-select{
          width: 80%;

          line-height: 60px;

          .selected {
            font-size: 1.2rem;
          }
        }
      }
    }

    @media (max-width: 430px) {
      // .tv{
      //   padding-top: 30%;
      // }

      .tv-choose-your-room{
        padding-top: 15%!important;
      }

      .tv-room{
        padding-top: 23%!important;
      }

      .tv-outside{
        padding-top: 24%!important;
      }

      .tv-bedroom{
        padding-top: 30%!important;
      }    
      
      .tv-kitchen{
        padding-top: 40%!important;
      }

      .tv-office{
        padding-top: 30%!important;
      }

      // .table-outside{
      //   content:url("../../assets/table-outside-mobile.png");
      //   width: 120%!important;
      //   left: -13.5%!important;
      // }

      .chairs-outside{
        content:url("../../assets/chairs-outside-mobile.png");
        width: 130%!important;
      }

      .menu-choose-room{
        h1{
          font-size: 1.6rem;
        }
      }
    }

    @media (max-width: 380px) {
      .tv-bedroom{
        padding-top: 50%!important;
      }
    }

    @media (max-width: 330px) {
      .tv-choose-your-room{
        padding-top: 57%;
      }

      .tv-office{
        padding-top: 30%;
      }
    }
  }

  
}

</style>
